module.exports = __webpack_public_path__ + "img/axios-logo.ee8a1b4d.png";